<template>
  <div class="main-container">
    <div class="bread" v-if="!!$route.query.recommend">
      <router-link :to="{ name: 'Index' }">首页</router-link>
      <span class="slash">/</span>
      <router-link
        :to="{
          name: 'IndexRecommendTeacher',
          query: {
            title: $route.query.title,
            recommend: $route.query.recommend,
          },
        }"
      >
        {{ $route.query.title }}
      </router-link>
      <span class="slash">/</span>
      <span class="current">
        {{ teacher.teacher_name || teacher.real_name }}
      </span>
    </div>
    <div class="bread" v-else>
      <router-link v-if="lastRoute.name" :to="{ name: lastRoute.name }">
        {{ lastRoute.label }}
      </router-link>
      <span v-else>一对一</span>
      <span class="slash">/</span>
      <span class="current">
        {{ teacher.teacher_name || teacher.real_name }}
      </span>
    </div>
    <div class="teacher-intro">
      <div class="clear intro-box">
        <div class="avatar f-left">
          <img :src="teacher.photo"  style="width: 301px;height: 360px"/>
          <p v-if="!isNormal || isPerios"></p>
        </div>
        <div class="f-left main" :class="isNormal ? 'normal' : ''">
          <div v-if="!isNormal || isPerios" class="is-normal">
            <div class="title-tag">
              <template>
                <span class="title" v-if="!isNormal && !isPerios">
                  {{ teacher.teacher_name }}
                </span>
                <span class="title" v-else>
                  {{ inviteTeacher.teacher_name }}
                </span>
              </template>
              <span class="t-tag" v-if="!isNormal">
                {{ teacher.level_name }}
              </span>
            </div>
            <p class="li-title">{{ teacher.marketing_language }}</p>


            <template>
              <div class="small-tag" v-if="!isNormal && !isPerios">
                <p v-if="teacher.sex == 0" class="tea-attr1">男</p>
                <p v-else class="tea-attr2">女</p>
                <p class="tea-attr3">{{ teacher.age }}岁</p>
                <p class="tea-attr4">{{ teacher.teach_age }}年教龄</p>
              </div>
              <div class="small-tag" v-else>
                <p v-if="inviteTeacher.sex == 0" class="tea-attr1">男</p>
                <p v-else class="tea-attr2">女</p>
                <p class="tea-attr3">{{ inviteTeacher.age }}岁</p>
                <p class="tea-attr4">{{ inviteTeacher.teach_age }}年教龄</p>
              </div>
            </template>
          </div>
          <div v-else class="not-normal">
            <span class="title">{{ teacher.real_name }}</span>
            <p class="li-title">{{ teacher.marketing_language }}</p>
            <ul class="set-attribute">
              <li v-for="(attr, index) in attrs" :key="index">
                <span>{{ attr.attr_name }}：</span>
                {{ attr.attr_value_names }}
              </li>
            </ul>
            <div class="line"></div>
          </div>
          <div class="li-desc" v-html="intro" v-if="intro"></div>

          <div class="li-desc" v-else>{{ teacher.introduction }}</div>
          <p v-if="!isNormal" class="li-price">
            <span class="text">计费约课收费:</span>
            <CurrencyNew
              :price="teacher.section_price"
              :priceTwo="true"
            ></CurrencyNew>
            <span class="unit">／课次</span>
          </p>
          <div class="vertical" v-if="!isNormal && isPerios"></div>
          <p
            v-if="isPerios"
            class="periods-price"
            :class="{ 'single-periods-price': isNormal && isPerios }"
          >
            <span class="text">课时约课收费:</span>
            <span class="periods-text">
              {{ inviteTeacher.section_price }}课时
            </span>
            <span class="unit">／课次</span>
          </p>
          <div class="teacherAdminIndex" v-if="teacher.is_consult == 1">
            <div
              class="lnk-login-register btn-normal"
              @click="
                $router.push({
                  name: 'TeacherAdminIndex',
                  query: { teacher_id: id },
                })
              "
            >
              咨询中心
            </div>
          </div>
        </div>
        <template v-if="false">
          <span class="f-right collect" v-if="flag == 1" @click="cancelCollect">
            已收藏
          </span>
          <span class="f-right collect" v-else @click="collect">收藏</span>
        </template>
      </div>
      <div v-if="teacher.tag_content" class="clear">
        <div
          class="tag f-left"
          v-for="(tag, index) in teacher.tag_content"
          :key="index"
        >
          {{ tag }}
        </div>
      </div>
    </div>
    <div class="teacher-main" v-if="intro">
      <BlockTabs
        class="block-tabs"
        :items="tabs"
        currentClass="bold5"
        @changeTab="changeTab"
      ></BlockTabs>
      <div class="tab-content" :class="'tab-content-' + tab.toString()">
        <div v-show="tab == 0">
          <div class="intro-item" v-for="(attr, index) in attrs" :key="index">
            <label>{{ attr.attr_name }}：</label>
            <span>{{ attr.attr_value_names }}</span>
          </div>
          <div class="intro-item">
            <label>老师介绍：</label>
            <span v-html="intro"></span>
          </div>
        </div>
        <div v-show="tab == 1">
          <ul class="sort clearfix">
            <li :class="{ active: sort == 0 }" @click="changeSort(0)">综合</li>
            <li :class="{ active: sort == 1 }" @click="changeSort(1)">最新</li>
            <li :class="{ active: sort == 2 }" @click="changeSort(2)">最热</li>
            <li
              class="sort-price"
              :class="{
                active: sort == 3 || sort == 4,
                desc: sort == 4,
                asc: sort == 3,
              }"
              @click="changeSort(sort == 4 ? 3 : 4)"
            >
              价格
            </li>
          </ul>
          <List
            class="list"
            ref="list"
            url="/api/app/teacher/mainCourse"
            :search="params"
            :limit="16"
            :alwaysShowPager="true"
            method="post"
          >
            <template v-slot="{ list }">
              <div class="course-list clearfix">
                <RichCourseItem
                  v-for="course in list"
                  :key="course.id"
                  :course="course"
                  :withRecommend="false"
                ></RichCourseItem>
              </div>
              <Empty v-if="list.length == 0" title="暂无课程安排，敬请期待" />
            </template>
          </List>
        </div>
        <div v-if="tab == 2" class="schedule">
          <div class="tabs" v-if="!isNormal && isPerios">
            <span
              class="periods"
              :class="{
                'active-tab': active == 1,
                'no-active-tab': active == 2,
              }"
              @click="changeChildTab(1)"
            >
              课时约课
            </span>
            <span
              class="charging"
              :class="{
                'active-tab': active == 2,
                'no-active-tab': active == 1,
              }"
              @click="changeChildTab(2)"
            >
              计费约课
            </span>
          </div>
          <el-tabs
            v-model="is_next"
            v-if="
              (!isNormal && isPerios && active == 2) ||
              (!isNormal && active == 2)
            "
          >
            <el-tab-pane
              v-for="(value, key) in weekTab"
              :key="key"
              :label="value"
              :name="key"
            >
              <OtoScheduleTable
                :teacherId="$route.params.id.toString()"
                :is_next="is_next"
              ></OtoScheduleTable>
            </el-tab-pane>
          </el-tabs>
          <ScheduleTable
            ref="scheduleTable"
            v-if="
              (!isNormal && isPerios && active == 1) ||
              (isPerios && active == 1)
            "
            url="/api/app/inviteTeacher/getInviteCourseList"
            :teacherId="inviteTeacher.teacher_id"
            @get-table-data="GetScheduleTable"
          >
            <template #head-left>
              <div class="left">
                <p
                  v-if="commonSetting.switch_sch_attr_grade == 1"
                  style="margin-right: 48px"
                  class="classs"
                  :title="getTitle(inviteTeacher.grade)"
                >
                  <span class="label">授课年级：</span>
                  <span
                    v-for="(item, index) in inviteTeacher.grade"
                    :key="item.id"
                  >
                    <template v-if="inviteTeacher.grade.length == index + 1">
                      {{ item.name }}
                    </template>
                    <template v-else>{{ item.name }}/</template>
                  </span>
                </p>
                <p
                  v-if="commonSetting.switch_sch_attr_classify == 1"
                  style="margin-right: 48px"
                  class="classify"
                  :title="getTitle(inviteTeacher.course_classify)"
                >
                  <span class="label">教学分类：</span>
                  <span
                    v-for="(item, index) in inviteTeacher.course_classify"
                    :key="item.id"
                  >
                    <template
                      v-if="inviteTeacher.course_classify.length == index + 1"
                    >
                      {{ item.name }}
                    </template>
                    <template v-else>{{ item.name }}/</template>
                  </span>
                </p>
                <p class="item" :title="getTitle(inviteTeacher.subjects)">
                  <span class="label">科目：</span>
                  <span
                    v-for="(item, index) in inviteTeacher.subjects"
                    :key="item.id"
                  >
                    <template v-if="inviteTeacher.subjects.length == index + 1">
                      {{ item.name }}
                    </template>
                    <template v-else>{{ item.name }}/</template>
                  </span>
                </p>
              </div>
            </template>
            <template #course-time="{ weekIndex, time }">
              <template v-if="courseTimes[weekIndex][time.id]">
                <div
                  v-if="courseTimes[weekIndex][time.id].status == 1"
                  class="can-appointment"
                  @click="onAppointment(courseTimes[weekIndex][time.id])"
                >
                  <span>可 预 约</span>
                </div>
                <div
                  v-else-if="
                    courseTimes[weekIndex][time.id].status == 2 ||
                    courseTimes[weekIndex][time.id].status == 3 ||
                    courseTimes[weekIndex][time.id].status == 4
                  "
                  class="full-appointment"
                >
                  <span>
                    {{
                      courseTimes[weekIndex][time.id].status == 2
                        ? "约 满"
                        : courseTimes[weekIndex][time.id].status == 3
                        ? "已预约"
                        : "过期"
                    }}
                  </span>
                </div>
              </template>
            </template>
          </ScheduleTable>
        </div>
        <div v-if="tab == 3" class="evaluate">
          <div class="tabs" v-if="!isNormal && isPerios">
            <span
              class="periods"
              :class="{
                'active-tab': evaluate_active == 1,
                'no-active-tab': evaluate_active == 2,
              }"
              @click="changeEvaluateChildTab(1)"
            >
              课时约课
            </span>
            <span
              class="charging"
              :class="{
                'active-tab': evaluate_active == 2,
                'no-active-tab': evaluate_active == 1,
              }"
              @click="changeEvaluateChildTab(2)"
            >
              计费约课
            </span>
          </div>
          <div
            class="appraise"
            v-if="
              (!isNormal && isPerios && evaluate_active == 2) ||
              (!isNormal && evaluate_active == 2)
            "
          >
            <div
              class="item clearfix"
              v-for="appraise in appraiseList"
              :key="appraise.id"
            >
              <img class="avatar" :src="appraise.avatar" />
              <div class="f-left right">
                <div class="clearfix">
                  <span class="user f-left">
                    {{ appraise.user_name + " 评价" }}
                  </span>
                  <span class="primary-color f-left">
                    {{ appraise.course_time }}
                  </span>
                  <span class="yue f-left">的约课</span>
                  <div class="f-left" style="position: relative">
                    <el-rate v-model="appraise.grade" class="f-left"></el-rate>
                    <div class="mask"></div>
                  </div>
                  <a
                    class="operate delete"
                    v-if="$store.state.user_info.id == appraise.uid"
                    @click="onCommentDelete(appraise)"
                  >
                    删除
                  </a>
                  <a
                    class="operate complaint"
                    v-else
                    @click="onComplaint(appraise)"
                  >
                    举报
                  </a>
                </div>
                <div class="clear tags">
                  <div class="tag" v-for="tag in appraise.tags" :key="tag">
                    {{ tag }}
                  </div>
                </div>
                <div class="content">{{ appraise.content }}</div>
                <div class="time">{{ appraise.created_at | tsFormatLong }}</div>
              </div>
            </div>
            <el-pagination
              background
              @current-change="handleAppraiseChange"
              :current-page="pageAppraise"
              :page-size="limitAppraise"
              layout="prev, pager, next, total, jumper"
              :total="totalAppraise"
              v-if="appraiseList.length > 0"
            ></el-pagination>
            <Empty
              v-if="appraiseList.length == 0"
              title="暂无讲师评价信息哦！"
            />
          </div>
          <div
            v-if="
              (!isNormal && isPerios && evaluate_active == 1) ||
              (isPerios && evaluate_active == 1)
            "
            style="margin-top: 25px"
          >
            <div
              class="periods-evaluate-item"
              v-for="(item, index) in evaluateList"
              :key="index"
            >
              <img :src="item.avatar" alt="" class="avatar" />
              <div class="message">
                <p class="user-name">{{ item.nickname }}</p>
                <p class="evaluate-time">
                  评价于 {{ item.s_created_at | tsFormatLong }}
                </p>
                <p class="evaluate-content">
                  {{ item.s_remark }}
                </p>
                <p class="class-time">
                  <font style="color: #bb1c20">
                    {{ item.course_time }}
                  </font>
                  的
                  <font style="color: #bb1c20">
                    {{ $store.getters.getSwitch("grade") ? item.name + "-" : ""
                    }}{{
                      $store.getters.getSwitch("classify")
                        ? item.classify_name + "-"
                        : ""
                    }}{{ item.sub_name }}
                  </font>
                  约课
                </p>
              </div>
            </div>
            <el-pagination
              background
              @current-change="handleEvaluateChange"
              :current-page="pageEvaluate"
              :page-size="limitEvaluate"
              layout="prev, pager, next, total, jumper"
              :total="totalEvaluate"
              v-if="evaluateList.length > 0"
            ></el-pagination>
            <Empty v-if="evaluateList.length == 0" title="暂无评价信息哦！" />
          </div>
        </div>
      </div>
    </div>
    <Complaint ref="complaint"></Complaint>
    <!--    课时约课-->
    <el-dialog
      title="课时约课"
      :close-on-click-modal="false"
      :visible.sync="periodsDlgShow"
      width="640px"
      :before-close="closeDlg"
      class="periods-dlg"
    >
      <div class="teacher_name_wrap">
        <span class="label">约课讲师：</span>
        <span class="teacher_name">{{ inviteTeacher.teacher_name }}</span>
      </div>
      <!--      选择课时包-->
      <template>
        <div class="select">
          <span class="label">课时包：</span>
          <el-select v-model="contracts_id" filterable @change="changePackage">
            <el-option
              v-for="item in packageList"
              :key="item.contracts_id"
              :label="item.contracts_title"
              :value="item.contracts_id"
            >
              {{ item.contracts_title }}
            </el-option>
          </el-select>
        </div>
      </template>
      <div
        class="select-radio"
        v-if="contracts_id && commonSetting.switch_sch_attr_grade == 1"
      >
        <span class="label">年级：</span>
        <el-radio-group v-model="gradeRadioValue">
          <el-radio
            :label="item.grade_id"
            v-show="contracts_id == item.contracts_id"
            v-for="(item, index) in packageList"
            :key="index"
          >
            {{ item.grade_name }}
          </el-radio>
        </el-radio-group>
      </div>
      <div
        class="select-radio"
        v-if="
          commonSetting.switch_sch_attr_classify == 1 &&
          course_classify.length > 0
        "
      >
        <span class="label">分类：</span>
        <el-radio-group v-model="classifyRadioValue">
          <el-radio
            :label="item.classify_id"
            v-for="item in course_classify"
            :key="item.classify_id"
          >
            {{ item.classify_name }}
          </el-radio>
        </el-radio-group>
      </div>
      <div class="select-radio" v-if="subjectList && subjectList.length > 0">
        <span class="label">科目：</span>
        <el-radio-group v-model="subjectsRadioValue" @change="changeSub">
          <el-radio
            :label="item.contracts_item_id"
            v-for="item in subjectList"
            :key="item.contracts_item_id"
          >
            {{ item.sub_name }}
          </el-radio>
        </el-radio-group>
      </div>
      <template v-if="is_set_chapters == 1">
        <div class="select">
          <span class="label">预约课次：</span>
          <el-cascader
            v-model="period"
            :options="periodList"
            filterable
          ></el-cascader>
        </div>
      </template>
      <div class="use-periods-wrap">
        <span class="label">消耗课时：</span>
        <span class="use-periods">{{ inviteTeacher.section_price }}课时</span>
        <span class="warning" v-if="warningText">
          <i class="el-icon-warning-outline"></i>
          {{ warningText }}
        </span>
      </div>
      <div class="teaching-method-wrap">
        <span class="label">授课方式：</span>
        <span class="teaching-method">
          {{ clickInviteCourse.type == 1 ? "直播" : "线下面授" }}
        </span>
      </div>
      <div>
        <span class="label">课次时间：</span>
        <span class="class-time-dlg">
          {{ clickInviteCourse.start_play | tsFormatDate }}
          {{ $pub.ts(clickInviteCourse.start_play, "minute") }}-
          {{ $pub.ts(clickInviteCourse.end_play, "minute") }}
        </span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDlg">取 消</el-button>
        <el-button type="primary" @click="submitAppointment">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="预约成功"
      :visible.sync="appointSuccessDlg"
      :show-close="false"
      width="640px"
      class="successDlg"
    >
      <p class="tips">请提前与讲师沟通，按时上课</p>
      <div
        class="topHalf"
        :style="{
          height:
            commonSetting.switch_sch_attr_grade == 1 &&
            commonSetting.switch_sch_attr_classify == 1
              ? '130px'
              : '100px',
        }"
      >
        <div class="left-wrap">
          <span class="label">约课讲师：</span>
          <span class="label-content">{{ inviteTeacher.teacher_name }}</span>
        </div>
        <div class="left-wrap" v-if="commonSetting.switch_sch_attr_grade == 1">
          <span class="label">年级：</span>
          <span class="label-content">
            {{ select_grade[0] && select_grade[0].name }}
          </span>
        </div>
        <div
          class="left-wrap"
          v-if="commonSetting.switch_sch_attr_classify == 1"
        >
          <span class="label">分类：</span>
          <span class="label-content">
            {{ select_classify[0] && select_classify[0].classify_name }}
          </span>
        </div>
        <div class="left-wrap">
          <span class="label">科目：</span>
          <span class="label-content">
            {{ select_subject[0] && select_subject[0].sub_name }}
          </span>
        </div>
        <div class="left-wrap">
          <span class="label">消耗课时：</span>
          <span class="label-content">
            {{ inviteTeacher.section_price }}课时
          </span>
        </div>
        <div class="left-wrap">
          <span class="label">授课方式：</span>
          <span class="label-content">
            {{ clickInviteCourse.type == 1 ? "直播" : "线下面授" }}
          </span>
        </div>
        <div class="left-wrap">
          <span class="label">课次时间：</span>
          <span class="label-content">
            {{ clickInviteCourse.start_play | tsFormatDate }}
            {{ $pub.ts(clickInviteCourse.start_play, "minute") }}-
            {{ $pub.ts(clickInviteCourse.end_play, "minute") }}
          </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onCloseAppointSuccessDlg">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import RichCourseItem from "../../components/rich/CourseItem.vue";
import OtoScheduleTable from "../../components/OtoScheduleTable.vue";
import ScheduleTable from "@/components/schedule/ScheduleTable.vue";
import Complaint from "@/components/community/components/Complaint.vue";
import List from "@/components/List.vue";

export default {
  name: "LecturerShow",
  components: {
    OtoScheduleTable,
    ScheduleTable,
    RichCourseItem,
    Complaint,
    List,
  },
  computed: {
    tabs() {
      let tabs = [];
      // tabs.push({ id: 0, name: "讲师简介" });
      tabs.push({ id: 1, name: "主讲课程" });
      if (
        (!this.isNormal &&
          this.$store.state.commonSetting.switch_oto_module == 1) ||
        this.isPerios
      ) {
        tabs.push({ id: 2, name: "约课课表" });
        tabs.push({ id: 3, name: "讲师评价" });
      }
      return tabs;
    },
    commonSetting() {
      return this.$store.state.commonSetting;
    },
    userId() {
      return this.$store.state.user_info.id;
    },
  },
  data() {
    return {
      course_classify: [], //分类列表
      contracts_id: "", //已选课时包
      subjectList: [], //科目列表
      periodList: [], //课次列表
      period: "", //预约课次
      id: "",
      teacher: {},
      inviteTeacher: {},
      isNormal: true, //是否是普通讲师,进而用于可以判断是否是计费约课讲师 true：非计费约课讲师 false:计费约课讲师
      isPerios: false, //是否是课时约课讲师 true:是,false：是
      periodsDlgShow: false,
      appointSuccessDlg: false,
      gradeRadioValue: null,
      subjectsRadioValue: null,
      classifyRadioValue: null,
      flag: 2,
      tab: 1,
      attrs: [],
      intro: "",
      packageList: [], //课时包列表
      courses: [],
      pageAppraise: 1,
      limitAppraise: 10,
      totalAppraise: 0,
      pageEvaluate: 1,
      is_set_chapters: 2,
      limitEvaluate: 10,
      totalEvaluate: 0,
      tags: [],
      appraiseList: [],
      evaluateList: [],
      lastRoute: {
        name: this.$route.query.route_name || "Oto",
        label: this.$route.query.route_label || "一对一",
      },
      is_next: 0,
      weekTab: {
        0: "本周课表",
        1: "下周课表",
      },
      sort: 0,
      params: {
        teacher_id: "",
        order_by: 0,
      },
      active: 1,
      evaluate_active: 1,
      table: {},
      settingDate: [],
      courseTimes: {
        0: {},
        1: {},
        2: {},
        3: {},
        4: {},
        5: {},
        6: {},
      },
      clickInviteCourse: {},
      warningText: "",
      select_grade: [],
      select_classify: [],
      select_subject: [],
    };
  },
  async created() {
    this.id = this.$route.params.id;
    this.params.teacher_id = this.$route.params.id;
    let data = await this.$http.get("/api/app/teacher/" + this.id);
    this.isPerios = data.inviteTeacher.length != 0;
    this.teacher = data.teacher;
    this.inviteTeacher = data.inviteTeacher;
    this.isNormal = !!data.teacher.real_name;
    this.flag = data.flag;
    if (!this.isNormal && !this.isPerios) {
      this.active = 2;
      this.evaluate_active = 2;
    }
    let dataAttr = await this.$http.get("/api/app/teacher/info/" + this.id);
    dataAttr.attr.forEach(a => {
      let attr_value_names = [];
      a.attr_value.forEach(av => {
        attr_value_names.push(av.attr_value_name);
      });
      a.attr_value_names = attr_value_names.join(",");
    });
    this.attrs = dataAttr.attr;
    this.intro = (dataAttr.intro || "").replace(/\n/g, "<br/>");
    // await this.getAppraise();
    // this.getPeriodsEvaluate(); //请求课时约课评价
    this.getOptionalList();
  },
  methods: {
    getTitle(value) {
      if (value && value.length > 0) {
        const data = value.map(item => item.name);
        return data.join("/");
      }
      return "";
    },
    //科目change
    async changeSub(value) {
      this.period = [];
      this.periodList = [];
      const data = this.subjectList.find(
        item => item.contracts_item_id == value,
      ); //获取contracts_item_id
      if (data) {
        //查询课次
        this.is_set_chapters = data.is_set_chapters;
        const res = await this.$http.get(
          `/api/app/inviteTeacher/optionalChapter/${data.contracts_item_id}`,
        );
        if (res && res.length > 0) {
          res.forEach(item => {
            item.label = item.title;
            item.value = item.id;
            item.children.forEach(i => {
              i.label = i.title;
              i.value = i.id;
            });
          });
          this.periodList = res;
        }
      }
    },
    //课时包change
    async changePackage(value) {
      this.is_set_chapters = 2;
      this.subjectsRadioValue = "";
      this.period = [];
      this.periodList = [];
      this.classifyRadioValue = null;
      this.subjectList = [];
      this.course_classify = [];
      const data = this.packageList.find(item => item.contracts_id == value);

      this.packageList.forEach(item => {
        if (this.contracts_id == item.contracts_id) {
          this.gradeRadioValue = item.grade_id;
        }
      });
      if (data) {
        this.course_classify = [
          { classify_id: data.classify_id, classify_name: data.classify_name },
        ];
        this.subjectList = data.contracts_item || [];
      }
    },
    //获取合同数据
    async getOptionalList() {
      if (
        this.$store.state.token &&
        this.$store.getters.getSwitch("contract")
      ) {
        const res = await this.$http.get(
          `/api/app/inviteTeacher/optionalContracts/${this.id}`,
        );
        this.packageList = res || [];
      }
    },
    GetScheduleTable(data) {
      this.settingDate = data.date;
      this.table = data;
      this.courseTimes = {
        0: {},
        1: {},
        2: {},
        3: {},
        4: {},
        5: {},
        6: {},
      };
      data.invite_course.forEach(i => {
        const pos = this.getCourseTimePos(i.start_play_date, i.timetable_id);
        if (!pos) return;
        let status; //1可预约单元格 ,2约满单元格(别人) ,3自己约的,4过期
        if (i.is_expired == 1) {
          status = 4;
        } else if (i.user_id == 0 && i.confirm_at == 0) {
          status = 1;
          //可预约
        } else {
          status = i.user_id == this.userId ? 3 : 2;
        }
        const data = {
          ...i,
          status,
        };
        this.courseTimes[pos.week][pos.time_id] = data;
      });
    },
    getCourseTimePos(dateStr, timeId) {
      const week = this.table.date.findIndex(i => i.date == dateStr);
      const time = this.table.course_time.find(i => i.id == timeId);
      return week != -1 && time
        ? {
            week,
            time_id: time.id,
          }
        : null;
    },
    async collect() {
      await this.$http.get("/api/app/teacher/collect/" + this.id, {}, true);
      this.$message({
        message: "收藏成功",
        type: "success",
      });
      this.flag = 1;
    },
    async cancelCollect() {
      await this.$http.get("/api/app/teacher/collect/" + this.id);
      this.$message({
        message: "取消收藏成功",
        type: "success",
      });
      this.flag = 2;
    },
    changeTab(item) {
      this.tab = item.id;
    },
    changeChildTab(tab) {
      this.active = tab;
    },
    changeEvaluateChildTab(tab) {
      this.evaluate_active = tab;
    },
    async getAppraise() {
      let data = await this.$http.post(
        "/api/app/teacher/comment?teacher_id=" + this.id,
        {
          page: this.pageAppraise,
          limit: this.limitAppraise,
        },
      );
      let tags = data.tag;
      tags = tags.sort((a, b) => b.count - a.count);
      this.tags = tags;
      this.totalAppraise = data.comment.total;
      let appraiseList = data.comment.list;
      appraiseList.forEach(a => {
        let times = a.course_time.split(" ");
        times[0] = times[0].replace(/-/g, "/");
        a.course_time = times.join(" ");
        if (!a.tag_content) {
          return;
        }
        a.tags = a.tag_content.split(",");
      });
      this.appraiseList = appraiseList;
    },
    async getPeriodsEvaluate() {
      let data = await this.$http.post(
        "/api/app/teacher/comment?teacher_id=" + this.id,
        {
          page: this.pageEvaluate,
          limit: this.limitEvaluate,
        },
      );
      this.totalEvaluate = data.inviteComment.total;
      this.evaluateList = data.inviteComment.list;
    },
    async handleAppraiseChange(page) {
      this.pageAppraise = page;
      // await this.getAppraise();
    },
    async handleEvaluateChange(page) {
      this.pageEvaluate = page;
      // await this.getPeriodsEvaluate();
    },
    async onCommentDelete(item) {
      await this.$promiseConfirm("删除后，该内容将不再展示，是否确认？", {
        type: "warning",
      });
      await this.$http.delete("/api/app/oto/comment/" + item.id);
      // await this.getAppraise();
    },
    onComplaint(item) {
      this.$refs.complaint.show(2, item.id);
    },
    changeSort(sort) {
      this.sort = sort;
      this.params.order_by = sort;
      this.$refs.list.searchRefresh();
    },
    resetDlg() {
      this.is_set_chapters = 2;
      this.gradeRadioValue = null;
      this.classifyRadioValue = null;
      this.subjectsRadioValue = null;
      this.course_classify = [];
      this.contracts_id = null;
      this.subjectList = []; //科目列表
      this.periodList = []; //课次列表
      this.period = "";
      this.warningText = "";
    },
    closeDlg() {
      this.resetDlg();
      this.periodsDlgShow = false;
    },
    onAppointment(inviteCourseItem) {
      if (!this.$store.state.token) {
        this.$LoginModal.login({ type: "passwordLogin", store: this.$store });
        return false;
      }
      this.clickInviteCourse = inviteCourseItem;
      this.periodsDlgShow = true;
    },
    async submitAppointment() {
      if (
        this.commonSetting.switch_sch_attr_grade == 1 &&
        this.gradeRadioValue == null
      ) {
        this.$message({
          type: "error",
          message: "请选择年级",
        });
        return;
      }
      if (!this.contracts_id) {
        this.$message({
          type: "error",
          message: "请选择课时包",
        });
        return;
      }
      if (
        this.commonSetting.switch_sch_attr_classify == 1 &&
        this.classifyRadioValue == null
      ) {
        this.$message({
          type: "error",
          message: "请选择分类",
        });
        return;
      }
      if (this.subjectsRadioValue == null) {
        this.$message({
          type: "error",
          message: "请选择科目",
        });
        return;
      }
      let params = {
        invite_course_id: this.clickInviteCourse.id,
        teacher_id: this.inviteTeacher.teacher_id,
        grade_id: this.gradeRadioValue,
        course_classify_id: this.classifyRadioValue,
        // subject_id: this.subjectsRadioValue,
        contracts_item_id: this.subjectsRadioValue,
        chapter_id: this.period && this.period.length > 0 ? this.period[1] : "",
      };
      let data = await this.$http.post(
        "/api/app/inviteTeacher/inviteTeacherCourse",
        params,
      );
      if (data.error) {
        this.warningText = data.error;
      } else {
        this.periodsDlgShow = false;
        this.packageList.forEach(item => {
          if (this.contracts_id == item.contracts_id) {
            this.select_grade = [
              {
                id: item.grade_id,
                grade_id: item.grade_id,
                name: item.grade_name,
                grade_name: item.grade_name,
              },
            ];
            this.gradeRadioValue = item.grade_id;
          }
        });
        this.select_classify = this.course_classify.filter(
          item => item.classify_id == this.classifyRadioValue,
        );
        this.select_subject = this.subjectList.filter(
          item => item.contracts_item_id == this.subjectsRadioValue,
        );
        this.resetDlg();
        this.periodsDlgShow = false;
        this.appointSuccessDlg = true;
        this.$refs.scheduleTable.requestTable();
      }
    },
    onCloseAppointSuccessDlg() {
      this.select_grade = [];
      this.select_classify = [];
      this.select_subject = [];
      this.appointSuccessDlg = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../css/oto-teacher.scss";
.periods-dlg {
  //min-height: 500px;
  /deep/ .el-dialog__body {
    min-height: 300px;
  }
}

.item {
  width: 270px;
  margin-top: 10px;
  margin-right: 14px !important;
}


.left {
  .classs {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    width: 200px;
  }
  .classify {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    width: 200px;
  }
  .item {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    width: 360px;
  }
}
.select {
  margin-bottom: 20px;
  .label {
    width: 80px;
    display: inline-block;
    white-space: nowrap;
  }

  /deep/ .el-input el-input--suffix {

    //height: 32px;
  }
  /deep/ .el-input__inner {
    //height: 32px;
    //line-height: 32px;
  }
  /deep/ .el-input__suffix {
    //height: 32px;
    //top: 5px;
  }
}
</style>
